import { useState, useEffect } from "react";

const timelineData = [
  {
    year: "2016",
    title: "INDULÁS",
    text: "Két évnyi felújítás és kiállításépítés után létrejött Magyarország egyik legizgalmasabb tárlata az alföldi arisztokrata kastélyok mindennapi életéről. A tárlat különlegessége, hogy nemcsak a főúri családok, hanem a szolgálók életét is megjeleníti, illetve hogy szakít az addigi gyakorlattal: műtárgyak helyett interaktív eszközökkel nyújt élményalapú tudásátadást.",
    stackMedia: true,
    images: [
      "youtube:CurHY8Mrkcc",
      "youtube:oJ-0hqLFGbs",
    ],
    events: [
      "Március 4–9.: próbaüzem csak regisztrációval, 10 órától negyedóránként indított 27 csoport, csoportonként átlagosan 20 fő",
      "Március 11–15.: tesztüzem bárki számára",
      "Március 14.: megnyílik a Szabadságunkért harcoltak című időszaki kiállítás",
      "Március 18.: megnyitás",
      "Március 19-től: üzemszerű működés a próbaüzem tapasztalatai alapján felmerült hibák és hiányosságok pótlását és javítását követően",
      "Április 2.: ötezredik látogató",
      "Augusztus 13.: az első gyertyafényes tárlatvezetés",
      "Augusztus 26.: a Kodály Filharmonikusok Debrecen koncertje a kastélyparkban",
      "Október 7.: megnyílik a Letétetett – bevégeztetett. Az Aradi Ereklyemúzeum relikviái című időszaki tárlat",
      "Október 22.: ötvenezredik látogató",
      "November 25.: első alkalommal gyűjtjük a cipősdobozokat",
    ],
  },
  {
    year: "2017-2018",
    title: "ARANYÉVEK",
    text: "A kastélyt évről évre többen látogatják, nemcsak a térség legnépszerűbb turisztikai attrakciójává nő, de országosan is a leglátogatottabb kastélyok közé kerül. A kastélynak és a kiállításának köszönhetően Gyula idegenforgalmában megjelenik a kulturális turizmus. Megérkeztek a felújításhoz és a kiállításhoz kapcsolódó első szakmai sikerek.",
    video: "ugv0QFeuSoQ",
    images: [
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2017_1-scaled-e1773747624744-1.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2017_2-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2017_3-scaled.jpg",
    ],
    eventGroups: [
      {
        year: "2017",
        items: [
          "Április 18.: a kastély megkapja a példaadó műemlék-felújításért járó ICOMOS-díjat",
          "Május 5.: megnyílik a HEREND I DNEREH című időszaki tárlat",
          "Június 7.: megérkezik a 100 ezredik látogató",
          "Július 14.: elindul az első szabadulószoba a Török toronyban (A turbánosok csapdájában – 2023 óta a Gyulai Várba költözött)",
          "Október 4.: a Beton Fesztivál »Betonépítészet tervezőknek« kategóriájában második helyezést ért el Földes László a gyulai Almásy-kastély tervezésével",
          "December 7.: Az eltemetett vár – A gyulai vár palánkerődítéseinek régészeti kutatása című időszaki kiállítás megnyitása",
        ],
      },
      {
        year: "2018",
        items: [
          "Január 18.: 150 ezredik látogató",
          "Május 9–12.: részvétel a European Museum of the Year Award-on, amivel a kastély Európa 40 legjobb kiállítása közé került",
          "Augusztus 10.: a 200 ezredik látogató köszöntése",
          "Szeptember 8.: megnyílik a Kincsek őrzője – 150 éves a gyulai Erkel Ferenc Múzeum című időszaki tárlat",
          "Szeptember 21.: Építőipari Nívódíjat hirdető emléktábla kerül a bejárathoz",
          "November 17.: első alkalommal festjük lilára az épületet a koraszülött világnapon",
        ],
      },
    ],
  },
  {
    year: "2019",
    title: "ÉLŐ KASTÉLY",
    text: "A nyitás óta tartó folyamatos fejlődés az ismertségben, látogatottságban is megnyilvánul. Ez volt talán az első év, amikor azt érezhettük, minden tekintetben elkészült a kastély főépülete: szabadulószobával belaktuk az egyik pincét és újabb nemzetközi elismerés érkezett. ",
    images: [
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2019_1-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2019_2-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2019_3-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2019_4-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2019_5-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2019_6-scaled.jpg",
    ],
    events: [
      "Március 16.: bemutattuk a kiállítótérben megismerhető ételeket tartalmazó Receptek a kastélyból című kiadványt",
      "Március 21.: megérkezik a 250 ezredik látogató",
      "Október 2.: elindul a kiskastélyszárny felújítása",
      "Október 29.: a 300 ezredik látogató a kastélyban",
      "November 17.: a kastély Heritage & Experience különdíjat kap a Heritage Hotels of Europe díjátadóján",
      "December 27.: a kastély második szabadulószobája, a Rejtély a kastélyban indulása",
    ],
  },
  {
    year: "2020",
    title: "ALKALMAZKODÁS",
    text: "A COVID és a járványügyi korlátozások miatt kreatív megoldásokat kellett találnunk, hogy a kényszerű zárva tartás ellenére megtartsuk az épület és a kiállítás iránti érdeklődést.",
    images: [
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2020_1-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2020_2-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2020_3-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2020_4-scaled.jpg",
    ],
    events: [
      "Március 17.: bezárunk a COVID-járvány miatt",
      "Március 20.: három nappal a bezárást követően elindítjuk 360 fokos kamerával rögzített online tárlatvezetésünket",
      "Április 10.: a kényszerű zárvatartás idejére elindul az Ablaktárlat",
      "Május 4.: közösségi média felületünkre felkerül az első online múzeumpedagógiai foglalkozás",
      "Május 15.: újra kinyitott a Kastély Kávézó és az ajándékbolt",
      "Május 23.: kinyitottuk a kiállítóteret is",
      "Június 25.: Alföld Quartet koncertje a kastélyparkban",
      "Július 4.: megnyílik Az oszmán hódoltság építészeti emlékei Gyulán című időszaki kiállítás a Török toronyban",
      "November 7.: elindul a kastély harmadik szabadulószobája Boszorkányok márpedig léteznek címmel",
      "November 11.: a COVID második hulláma miatt ismét bezárunk",
      "November 20.: első alkalommal festjük kékre az épületet a gyermekjogi világnapon",
    ],
  },
  {
    year: "2021",
    title: "KITELJESEDÉS",
    text: "A COVID miatti nehéz évkezdet ellenére végleg bebetonoztuk magunkat az ország legjobb kiállítóhelyei és látogatóközpontjai között. A földszinti épületszárny megnyitásával és egy rangos turisztikai kitüntetéssel teljesedett ki a kastély története és jutott egyfajta szakmai csúcsra.",
    images: [
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2021_1-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2021_2-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2021_3-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2021_41.jpg",
    ],
    events: [
      "Május 1.: újra kinyitottunk a COVID második hullámát követően",
      "Október 13.: átadták a Stefánia-szárnyat",
      "December 17.: Kőrösi Csoma Sándor-nagydíjat kap a sikeres látogatómenedzsmentért és az ágazat újraindításában végzett munkájáért Fekete-Dombi Ildikó, a kastélyt is működtető nonprofit kft. ügyvezető igazgatója",
    ],
  },
  {
    year: "2022-2025",
    title: "BUMM",
    text: "Az ország máig egyik legjobb állandó kiállítása mellé felzárkóztak, alkalmanként a hangsúlyt is átvették az időszaki kiállítótérbe épített blockbuster-tárlatok. A Sisi- és Munkácsy-kiállítások a műtárgyak értéke és a nevek miatt jelentettek szenzációt, a Fűző és forradalom az élményalapú történetmesélés és a téma aktualitása miatt vált azzá. A korszak végére a kastély túllépett a sima főúri életmód bemutatásán, s ma már mélységi témákhoz nyúl. Tacskó Dénes figurájának megjelenésével pedig még inkább családbaráttá vált a látogatóközpont. A társadalmi felelősségvállalás tudatos tevékenységgé vált jótékonysági, érzékenyítő és humanitárius kampányokban való részvétellel.",
    images: [
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2023_2.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2023_5-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2023_6-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2024_1-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2024_3-scaled.jpg",
      "https://gyulaikastely.hu/wp-content/uploads/2026/03/2024_2-scaled.jpg",
    ],
    eventGroups: [
      {
        year: "2022",
        items: [
          "Március 19.: bemutattuk a kastély új kabalafiguráját, Gróf Tacskó Dénest (Döncit)",
          "Március 19.: az első Tacskótalálkozó",
          "Május 25.: megnyílik a Gödöllői Királyi Kastéllyal közös Úton Erzsébet királynéval című időszaki kiállítás",
          "November 24.: a vendégértékelések alapján a kastély második lett az Év Turisztikai Attrakciója kategóriában",
        ],
      },
      {
        year: "2023",
        items: [
          "Március 19.: elindul Kastélytúra Tacskó Döncivel elnevezésű gyermek tárlatvezetésünk",
          "Április 15.: megnyílik a Száműzöttként Madeirán című időszaki emlékkiállítás",
          "Április 21.: 500 ezredik látogató",
          "December 7.: megnyílik a Munkácsy: a sikersztori című időszaki tárlat",
        ],
      },
      {
        year: "2024",
        items: [
          "Június 21.: árusítani kezdjük a kizárólag nálunk kapható Nemzeti illat nevű parfümöt",
        ],
      },
      {
        year: "2025",
        items: [
          "Április 24.: második alkalommal kap ICOMOS-díjat a kastély, ezúttal a Példaadó Műemlékgondozásért",
          "Június 19.: megnyílik a Fűző és forradalom című időszaki kiállítás",
        ],
      },
    ],
  },
  {
    year: "2026",
    title: "JUBILEUMI ÉV",
    text: "Jubileumi programok",
    showEventsAlways: true,
    images: [
    ],
    events: [
      "Március 18.: Kastélyműködtetés a XXI. században – Tíz év egy vidéki kastély életében – szakmai konferencia",
      "Március 21.: 10 éves a Gyulai Almásy-kastély Látogatóközpont – Születésnap a látogatókkal és V. Jubileumi Tacskótalálkozó",
      "Március 21-től minden nyitvatartási napon 14.30: Itt éltek, így éltek… – Tematikus tárlatvezetés a kastélyt az egykor itt élt személyeken (arisztokratákon és a személyzet tagjain) keresztül mutatja be.",
      "Március 28-tól minden szombaton 17.00: Stefánia-kör – Látogatás a kastély Stefánia-szárnyában az épületrész történetének, névadójának, egykori és mai funkcióinak megismerésével.",
      "Női Irodalmi Kávéház – Középpontban a Fűző és forradalom c. időszaki kiállítás. Dr. Erdész Ádám, történész-levéltáros beszélget: április 15-én Budai Lotti írónővel, május 13-án Fábián Janka írónővel, június 10-én Farkas Wellmann Éva költővel. A kortárs irodalmárok a kiállításban saját alkotásuk részletét olvassák fel.",
      "Június 12. (péntek) 17.00: Platón: Szókratész védőbeszéde koncertszínház egy részben az Almásy-kastély Látogatóközpont kápolnájában.",
      "elPÉKesztő: kovászos műhelymunka minden hónapban a kastély Csemegetárában "
    ],
  },
];

function EventText({ text }) {
  const idx = text.indexOf(": ");
  if (idx === -1) return <>{text}</>;
  return (
    <>
      <span style={{ color: "#B41E8E", fontWeight: 600 }}>{text.slice(0, idx + 1)}</span>
      {text.slice(idx + 1)}
    </>
  );
}

function CardContent({ item, active, isMobile }) {
  return (
    <div style={{
      background: "#fff",
      border: active ? "2px solid #B41E8E" : "2px solid rgba(161,138,80,0.07)",
      borderRadius: 4,
      padding: isMobile ? "16px 14px 12px" : "20px 20px 16px",
      boxShadow: active
        ? "0 20px 60px rgba(161,138,80,0.15), 0 0 0 1px rgb(180,30,142)"
        : "0 8px 32px rgba(161,138,80,0.4)",
      transition: "all 0.3s ease",
      position: "relative",
      overflow: "hidden",
    }}>
      {/* corner accent */}
      <div style={{
        position: "absolute", top: 0, right: 0,
        width: 60, height: 60,
        background: active
          ? "linear-gradient(225deg, rgba(180,30,142,0.3) 0%, transparent 60%)"
          : "linear-gradient(225deg, rgba(255,255,255,0.04) 0%, transparent 60%)",
        transition: "all 0.3s",
      }} />

      <div style={{
        fontSize: isMobile ? 18 : 30, color: "#B41E8E", letterSpacing: "0.25em",
        textTransform: "uppercase", marginBottom: 10,
      }}>
        {item.title}
      </div>

      <p style={{
        color: "#A18A50", fontSize: isMobile ? 13 : 16, lineHeight: 1.65,
        margin: "0 0 14px", textAlign: "justify",
      }}>
        {item.text}
      </p>

      {/* Top video (if defined separately) */}
      {item.video && (
        <div style={{ width: "100%", aspectRatio: "16/9", borderRadius: 2, overflow: "hidden", marginBottom: 6 }}>
          <iframe
            src={`https://www.youtube.com/embed/${item.video}`}
            style={{ width: "100%", height: "100%", border: "none" }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      )}

      {/* Images / inline videos */}
      {(() => {
        const count = item.images.length;
        const cols = item.stackMedia ? 1 : count === 1 ? 1 : item.video ? 3 : 2;
        const imgH = isMobile
          ? (cols === 1 ? 180 : cols === 3 ? 90 : 120)
          : (cols === 1 ? 300 : cols === 3 ? 160 : 200);
        return (
          <div style={{ display: "grid", gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 6 }}>
            {item.images.map((src, j) => {
              const isYT = src.startsWith("youtube:");
              return (
                <div key={j} style={{ height: isYT ? undefined : imgH, aspectRatio: isYT ? "16/9" : undefined, borderRadius: 2, overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)" }}>
                  {isYT ? (
                    <iframe
                      src={`https://www.youtube.com/embed/${src.replace("youtube:", "")}`}
                      style={{ width: "100%", height: "100%", border: "none" }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <img
                      src={src}
                      alt=""
                      style={{
                        width: "100%", height: "100%",
                        objectFit: "cover",
                        filter: active ? "sepia(0.2) brightness(0.95)" : "grayscale(0.4) brightness(0.8)",
                        transition: "filter 0.4s ease",
                      }}
                    />
                  )}
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* Events */}
      {(item.events || item.eventGroups) && (
        <div style={{ marginTop: 14 }}>
          {(active || item.showEventsAlways) ? (
            <>
              {item.events && (
                <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                  {item.events.map((ev, k) => (
                    <li key={k} style={{
                      color: "#A18A50", fontSize: isMobile ? 12 : 14, lineHeight: 1.7,
                      paddingBottom: 4, marginBottom: 4, textAlign: "left",
                      borderBottom: k < item.events.length - 1 ? "1px solid rgba(161,138,80,0.15)" : "none",
                    }}>
                      <EventText text={ev} />
                    </li>
                  ))}
                </ul>
              )}
              {item.eventGroups && item.eventGroups.map((group, g) => (
                <div key={g} style={{ marginBottom: g < item.eventGroups.length - 1 ? 12 : 0 }}>
                  <div style={{
                    fontSize: 11, fontWeight: 700, color: "#B41E8E",
                    letterSpacing: "0.15em", textTransform: "uppercase",
                    marginBottom: 6, borderBottom: "1px solid rgba(180,30,142,0.2)",
                    paddingBottom: 3,
                  }}>
                    {group.year}
                  </div>
                  <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                    {group.items.map((ev, k) => (
                      <li key={k} style={{
                        color: "#A18A50", fontSize: isMobile ? 12 : 14, lineHeight: 1.7,
                        paddingBottom: 4, marginBottom: 4, textAlign: "left",
                        borderBottom: k < group.items.length - 1 ? "1px solid rgba(161,138,80,0.15)" : "none",
                      }}>
                        <EventText text={ev} />
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </>
          ) : (
            <div style={{
              color: "#A18A50", fontSize: 12, letterSpacing: "0.08em",
              textTransform: "uppercase", display: "flex", alignItems: "center", gap: 6,
            }}>
              Részletes események <span style={{ fontSize: 14 }}>↓</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function Timeline() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: "#ECECEC",
      fontFamily: "archer",
      overflow: "hidden",
      position: "relative",
    }}>
      {/* Grain overlay */}
      <div style={{
        position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E")`,
        opacity: 0.4,
      }} />

      {/* Ambient glow */}
      <div style={{
        position: "fixed", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        width: 900, height: 400,
        background: "radial-gradient(ellipse, rgba(180, 130, 142, 0.06) 0%, transparent 70%)",
        pointerEvents: "none", zIndex: 0,
      }} />

      {/* Header */}
      <div style={{ textAlign: "center", paddingTop: isMobile ? 36 : 56, paddingBottom: 12, position: "relative", zIndex: 1, padding: isMobile ? "36px 20px 12px" : "56px 0 12px" }}>
        <div style={{
          fontSize: isMobile ? 18 : 30, letterSpacing: "0.35em", color: "#A18A50",
          textTransform: "uppercase", marginBottom: 12,
        }}>
          Idővonal
        </div>
        <h1 style={{
          fontSize: isMobile ? "clamp(22px, 6vw, 32px)" : "clamp(32px, 5vw, 58px)",
          color: "#B41E8E",
          margin: 0,
          fontWeight: 400,
          letterSpacing: "-0.02em",
          lineHeight: 1.2,
        }}>
        </h1>
      </div>

      {/* ── MOBILE layout ── */}
      {isMobile && (
        <div style={{ position: "relative", zIndex: 1, padding: "24px 16px 60px 16px" }}>
          {/* Vertical line */}
          <div style={{
            position: "absolute",
            left: 37,
            top: 24, bottom: 60,
            width: 1,
            background: "linear-gradient(180deg, transparent, #A18A50 4%, #806c3a 96%, transparent)",
          }} />

          {timelineData.map((item, i) => (
            <div key={i} style={{ display: "flex", gap: 12, marginBottom: 20 }}>
              {/* Left: dot + year */}
              <div style={{ width: 44, flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 4 }}>
                <div style={{
                  fontSize: 15, fontWeight: 700,
                  color: activeIndex === i ? "#B41E8E" : "#A18A50",
                  letterSpacing: "0.03em", textAlign: "center",
                  marginBottom: 6, lineHeight: 1.2,
                  transition: "color 0.3s",
                }}>
                  {item.year}
                </div>
                <div style={{
                  width: activeIndex === i ? 14 : 10,
                  height: activeIndex === i ? 14 : 10,
                  borderRadius: "50%",
                  background: activeIndex === i ? "#B41E8E" : "#A18A50",
                  boxShadow: activeIndex === i ? "0 0 14px rgba(180,30,142,0.7)" : "none",
                  transition: "all 0.3s ease",
                  zIndex: 2,
                  flexShrink: 0,
                }} />
              </div>

              {/* Right: card */}
              <div
                style={{ flex: 1, cursor: "pointer", transform: activeIndex === i ? "translateY(-4px)" : "none", transition: "transform 0.3s ease" }}
                onClick={() => setActiveIndex(activeIndex === i ? null : i)}
              >
                <CardContent item={item} active={activeIndex === i} isMobile={true} />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ── DESKTOP layout ── */}
      {!isMobile && (
        <>
          <div style={{
            overflowX: "auto",
            overflowY: "visible",
            paddingBottom: 60,
            paddingTop: 30,
            position: "relative",
            zIndex: 1,
            scrollbarWidth: "auto",
            scrollbarColor: "rgb(161, 138, 80) #ECECEC",
            cursor: "grab",
          }}
            onMouseDown={(e) => {
              const el = e.currentTarget;
              el.style.cursor = "grabbing";
              const startX = e.pageX - el.offsetLeft;
              const scrollLeft = el.scrollLeft;
              const onMove = (ev) => { el.scrollLeft = scrollLeft - (ev.pageX - el.offsetLeft - startX); };
              const onUp = () => {
                el.style.cursor = "grab";
                window.removeEventListener("mousemove", onMove);
                window.removeEventListener("mouseup", onUp);
              };
              window.addEventListener("mousemove", onMove);
              window.addEventListener("mouseup", onUp);
            }}
          >
            <div style={{
              display: "flex",
              alignItems: "flex-start",
              minWidth: "max-content",
              padding: "0 80px",
              gap: 0,
            }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
                {/* Year + axis row */}
                <div style={{ display: "flex", alignItems: "center", height: 80, position: "relative" }}>
                  {/* Horizontal line */}
                  <div style={{
                    position: "absolute", top: "50%", left: 16, right: 16, height: 1,
                    background: "linear-gradient(90deg, transparent, #A18A50 8%, #806c3a 92%, transparent)",
                    transform: "translateY(-50%)",
                  }} />
                  {timelineData.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        width: 500, margin: "0 16px",
                        display: "flex", flexDirection: "column", alignItems: "center",
                        position: "relative", cursor: "pointer",
                      }}
                      onClick={() => setActiveIndex(activeIndex === i ? null : i)}
                    >
                      <div style={{
                        fontSize: 30, fontWeight: 400,
                        color: activeIndex === i ? "#B41E8E" : "#A18A50",
                        letterSpacing: "0.05em", transition: "color 0.3s ease",
                        userSelect: "none", marginBottom: 10,
                      }}>
                        {item.year}
                      </div>
                      <div style={{
                        width: activeIndex === i ? 14 : 10,
                        height: activeIndex === i ? 14 : 10,
                        borderRadius: "50%",
                        background: activeIndex === i ? "#B41E8E" : "#A18A50",
                        boxShadow: activeIndex === i ? "0 0 18px rgba(180,30,142,0.7)" : "none",
                        transition: "all 0.3s ease", zIndex: 2,
                      }} />
                    </div>
                  ))}
                </div>

                {/* Cards row */}
                <div style={{ display: "flex", alignItems: "flex-start", gap: 0, minHeight: 550 }}>
                  {timelineData.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        width: 500, margin: "0 16px", cursor: "pointer",
                        transform: activeIndex === i ? "translateY(-8px)" : "translateY(0)",
                        transition: "transform 0.3s ease",
                      }}
                      onClick={() => setActiveIndex(activeIndex === i ? null : i)}
                    >
                      <CardContent item={item} active={activeIndex === i} isMobile={false} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Scroll hint */}
          <div style={{
            textAlign: "center", color: "#3a3555", fontSize: 11,
            letterSpacing: "0.3em", textTransform: "uppercase",
            paddingBottom: 32, position: "relative", zIndex: 1,
          }}>
            ← Csúsztass és fedezz fel! →
          </div>
        </>
      )}

      <style>{`
        ::-webkit-scrollbar { height: 8px; }
        ::-webkit-scrollbar-track { background: #1a1a24; }
        ::-webkit-scrollbar-thumb { background: #A18A50; border-radius: 2px; }
      `}</style>
    </div>
  );
}
